import { ADS_STORAGE_KEY, ADS_TOUCHES_LIMIT, AD_PAGES_PREFIX } from 'define';

const { pathname, href } = window.location;
const isAdPage = pathname === AD_PAGES_PREFIX || pathname.startsWith(`${AD_PAGES_PREFIX}/`);

if (isAdPage) {
  const date = new Date().toISOString().split('T')[0];
  const touches = JSON.parse(window.localStorage.getItem(ADS_STORAGE_KEY)) ?? [];

  if (!touches.some(touch => touch.date === date && touch.url === href)) {
    const updatedTouches = [...touches, { date, url: href }].slice(-ADS_TOUCHES_LIMIT);
    window.localStorage.setItem(ADS_STORAGE_KEY, JSON.stringify(updatedTouches));
  }
}
